import { render, staticRenderFns } from "./Cancel.vue?vue&type=template&id=4bdb486d&scoped=true&"
var script = {}
import style0 from "./Cancel.vue?vue&type=style&index=0&id=4bdb486d&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdb486d",
  null
  
)

export default component.exports